import { render } from "./RecursoConcha.vue?vue&type=template&id=71e1d1c3&scoped=true"
import script from "./RecursoConcha.vue?vue&type=script&lang=js"
export * from "./RecursoConcha.vue?vue&type=script&lang=js"

import "./RecursoConcha.vue?vue&type=style&index=0&id=71e1d1c3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71e1d1c3"]])

export default __exports__